<template>
    <div id="create-rule-page">
        <a-steps v-model="currentTab" size="small">
            <a-step :title="$t('ticimax.findTargetMembers')" />
            <a-step :title="$t('ticimax.automationTimer')" />
            <a-step :title="$t('ticimax.configureMessage')" />
            <a-step :title="$t('ticimax.completeAutomationRule')" />
        </a-steps>
        <div class="page-content">
            <div v-if="currentTab === 0">
                <MemberSelector :channel="channel" v-model="model.filterGroups" />
            </div>
            <div v-if="currentTab === 1">
                <RRuleGenerator :channel="channel" v-model="model.rrule" />
            </div>
            <div v-if="currentTab === 2">
                <TemplateSelector :channel="channel" v-model="model" />
            </div>
            <div v-if="currentTab === 3">
                <RuleSettings :channel="channel" v-model="model" />
            </div>
        </div>
        <div class="footer-actions">
            <SupsisButton ghost @click="cancel"> {{ $t("message.cancel") }}</SupsisButton>
            <SupsisButton primary @click="prev" :disabled="!prevAvailable()">
                <i class="material-icons">arrow_back</i>
                {{ $t("ticimax.previous") }}
            </SupsisButton>
            <SupsisButton primary @click="next" :disabled="!nextAvailable()" v-if="!isSubmitAvailable()">
                {{ $t("message.next") }}
                <i class="material-icons">arrow_forward</i>
            </SupsisButton>
            <SupsisButton ghost @click="submit" v-else>
                <i class="material-icons">save</i>
                {{ $t("ticimax.createAutomation") }}
            </SupsisButton>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import moment from "moment/moment";
import MoneyFormatter from "../../../../../../components/MoneyFormatter.vue";
import log2 from "../../../../../../utils/log2";
import MemberSelector from "./MemberSelector.vue";
import RRuleGenerator from "./RRuleGenerator.vue";
import TemplateSelector from "./TemplateSelector.vue";
import RuleSettings from "./RuleSettings.vue";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import { TICIMAX_API } from "../../../../../../api/ticimax";
import { sendSocketMessage } from "../../../../../../utils/socketStream";
import { mapState } from "vuex";

const log = log2("CreateRule");
export default {
    name: "CreateRule",
    components: {
        RuleSettings,
        TemplateSelector,
        RRuleGenerator,
        MemberSelector,
        MoneyFormatter,
        SupsisButton,
    },
    props: {
        channel: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site?._id,
        }),
    },
    data: function () {
        return {
            loadingInstance: null,
            rowStyleOption: {
                stripe: true,
            },
            cellStyleOption: {
                bodyCellClass: function ({ row, column, rowIndex }) {
                    const classNames = [column.key];

                    return classNames.join(" ");
                },
            },
            currentTab: 0, //filters,rrule,message,settings
            model: {
                name: "Untitled Messaging Automation",
                filterGroups: {
                    operator: "or",
                    groups: [],
                },
                rrule: "",
                selectedTemplate: null,
                templateParams: [],
                channel: null,
                resendEnabledAfterDays: 30,
            },
        };
    },
    methods: {
        isValid() {
            if ((this.model.rrule?.length || 0) <= 0) {
                this.$message.error("Please select a date for the automation to start");
                return false;
            }
            if ((this.model.filterGroups?.groups?.length || 0) <= 0) {
                this.$message.error("Please select at least one target member group");
                return false;
            }
            if (!this.model.selectedTemplate) {
                this.$message.error("Please select a template message");
                return false;
            }
            if (this.model.templateParams.name <= 0) {
                this.$message.error("Automation Rule Name is required");
                return false;
            }
            return true;
        },

        getMaxWidth() {
            return window.innerWidth - 350;
        },
        next() {
            this.currentTab++;
        },
        prev() {
            this.currentTab--;
        },
        nextAvailable() {
            return this.currentTab < 3;
        },
        prevAvailable() {
            return this.currentTab > 0;
        },
        isSubmitAvailable() {
            return this.currentTab === 3;
        },
        submit() {
            if (!this.isValid()) {
                return;
            }
            TICIMAX_API.createAutomationRule(
                this.model.name,
                this.model.filterGroups,
                this.model.rrule,
                this.model.selectedTemplate,
                this.model.templateParams,
                this.model.channel,
                this.model.resendEnabledAfterDays
            ).then((res) => {
                this.$message.success("Automation Rule Created Successfully");
                this.$emit("ok");
                sendSocketMessage("automation ticimax-automation-added", {
                    siteId: this.siteId,
                });
            });
        },
        cancel() {
            this.$emit("cancel");
        },
    },
    mounted() {},
    watch: {},
};
</script>

<style scoped lang="scss">
.header {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;

    border-bottom: 1px solid var(--color-border-default);

    .title {
        font-size: 18px;
        font-weight: 700;
        color: var(--color-text-strong-default);
        padding-left: 5px;
    }

    .subtitle {
        font-size: 14px;
        color: var(--color-text-strong-default);
    }
}

#create-rule-page {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    width: 100%;
    .footer-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        position: fixed;
        right: 10px;
        width: 100%;
        bottom: 0;
        background: white;
        z-index: 999;
        padding: 10px;
    }
}
</style>
